import { ReactNode } from 'react';

import { Box, Flex, Heading, Text } from '@chakra-ui/react';

import { ContentContainer } from '~/components/container';
import { HeadingWithEmphasis } from '~/components/heading-with-emphasis';
import { Ticket } from '~/components/ticket';

export type FeaturedProgramSectionProps = {
  programsSlot: ReactNode;
};

export function FeaturedProgramSection({ programsSlot }: FeaturedProgramSectionProps) {
  const title = `**Get 50% off** one-time purchases of Microsoft Nanodegree Programs`;
  return (
    <Box
      as='section'
      bgColor='accent.sky.100'
      padding={{
        base: '40px 0px',
        md: '80px 0px',
      }}
    >
      <ContentContainer>
        <Flex
          alignItems='center'
          flexDirection='column'
          gap={2}
          justifyContent='center'
          mb={{
            base: 6,
            md: 8,
          }}
        >
          <HeadingWithEmphasis
            text={title}
            emphasisProps={{
              fontWeight: '500',
              color: 'blue.500',
            }}
            headingProps={{
              as: 'h2',
              size: {
                base: 'marketing-xl',
                md: 'marketing-3xl',
              },
              textAlign: 'center',
              whiteSpace: {
                md: 'pre-wrap',
              },
              mb: 4,
            }}
          />
          <Flex
            alignItems='center'
            as='p'
            justifyContent='center'
            gap={{
              base: 2,
              md: 4,
            }}
          >
            <Heading
              as='span'
              fontWeight='400'
              whiteSpace='nowrap'
              size={{
                base: 'xs',
                md: 'marketing-lg',
              }}
            >
              Use code
            </Heading>
            <Box as='span' maxWidth='232px'>
              <Ticket code='MICROSOFT50' width={275} />
            </Box>
            <Heading
              as='span'
              fontWeight='400'
              whiteSpace='nowrap'
              size={{
                base: 'xs',
                md: 'marketing-lg',
              }}
            >
              at checkout
            </Heading>
          </Flex>
          <Text as='small' color='gray.700' fontWeight='500' size='caption' textAlign='center'>
            (Excludes All Access subscription)
          </Text>
        </Flex>
        {programsSlot}
      </ContentContainer>
    </Box>
  );
}
